<p class="mb-10">
  {{ 'kontoverbindungen.edit.intro' | translate }}
</p>
<div class="row">
  <div class="col col-md-4">
    {{ 'kontoverbindungen.edit.account-owner' | translate }}
  </div>
  <div class="col-8 col-md text-right order-md-last"></div>
  <div class="col-12 col-md-auto sux-text-medium mt-0 mb-10 mb-md-5">
    {{ kontoverbindung.inhaber }}
  </div>
</div>
<hr class="mt-1" />

<kvb-iban-bic
  #ibanBicComponent
  [iban]="kontoverbindung.iban"
  (ibanValidated)="onIbanValidated($event)"
></kvb-iban-bic>
<div class="sux-btn-group">
  <sux-button layout="primary" (click)="saveKontoverbindung()" [disabled]="isSaveButtonDisabled">{{
    'kontoverbindungen.edit.button.save' | translate
  }}</sux-button>
  <sux-button layout="secondary" (click)="ibanBicComponent.onResetClick()">{{
    'kontoverbindungen.edit.button.reset' | translate
  }}</sux-button>
</div>

<sux-exception [exceptions]="exceptions"></sux-exception>
